"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWidget = exports["default"] = exports.WidgetContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _state = require("@nicbase/state");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _widgets = require("../widgets/widgets.actions");

var _portalContext = require("./portal-context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var overwriteMerge = function overwriteMerge(destinationArray, sourceArray) {
  return sourceArray;
};

var WidgetContext = /*#__PURE__*/_react["default"].createContext(undefined);

exports.WidgetContext = WidgetContext;

var useWidget = function useWidget() {
  var widgetContext = (0, _react.useContext)(WidgetContext);

  if (widgetContext === undefined) {
    throw Error('useWidget must be used within a WidgetProvider');
  }

  return widgetContext;
};

exports.useWidget = useWidget;

var WidgetProvider = function WidgetProvider(_ref) {
  var widget = _ref.widget,
      children = _ref.children;
  var dispatch = (0, _reactRedux.useDispatch)();
  var widgetId = widget.id,
      _widget$settings = widget.settings,
      settings = _widget$settings === void 0 ? {} : _widget$settings;

  var _usePortal = (0, _portalContext.usePortal)(),
      portalId = _usePortal.id;

  var _useApplicationState = (0, _state.useApplicationState)(),
      state = _useApplicationState.state;

  var _useActions = (0, _state.useActions)(),
      updateFilters = _useActions.updateFilters;

  var _useState = (0, _react.useState)(settings),
      _useState2 = _slicedToArray(_useState, 2),
      changes = _useState2[0],
      setChanges = _useState2[1];

  var apply = (0, _react.useCallback)(function () {
    var instantChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var newSettings = instantChanges;

    if (typeof instantChanges === 'function') {
      newSettings = instantChanges(settings);
    } else {
      newSettings = (0, _deepmerge["default"])(changes, instantChanges, {
        arrayMerge: overwriteMerge
      });
    }

    setChanges(newSettings);
    dispatch((0, _widgets.updateWidgetSettings)(widgetId, newSettings, portalId));
  }, [changes, dispatch, portalId, settings, widgetId]);
  var reset = (0, _react.useCallback)(function () {
    setChanges(settings);
  }, [settings]);
  var update = (0, _react.useCallback)(function (newChanges) {
    setChanges(function (prevChanges) {
      if (typeof newChanges === 'function') {
        return newChanges(prevChanges);
      }

      return (0, _deepmerge["default"])(prevChanges, newChanges, {
        arrayMerge: overwriteMerge
      });
    });
  }, []);
  var widgetFilters = state.filters[widgetId];
  var filters = (0, _react.useMemo)(function () {
    return {
      values: widgetFilters,
      update: function update(values) {
        return updateFilters({
          widgetId: widgetId,
          values: values
        });
      }
    };
  }, [updateFilters, widgetFilters, widgetId]);
  var enhancedWidget = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, widget), {}, {
      settings: {
        current: settings,
        changes: changes,
        update: update,
        reset: reset,
        apply: apply
      },
      filters: filters
    });
  }, [apply, changes, filters, reset, settings, update, widget]);
  return /*#__PURE__*/_react["default"].createElement(WidgetContext.Provider, {
    value: enhancedWidget
  }, children);
};

var _default = WidgetProvider;
exports["default"] = _default;